import { createReducer } from 'redux-create-reducer';

import { WINDOW_RELOAD } from '../types';

const initialState = { type: '', message: '' };

const redirectReducer = createReducer(initialState, {
  [WINDOW_RELOAD]: (state, { payload }) => {
    window.location.reload();
    return { type: 'WINDOW_RELOAD', message: payload };
  },

});

export default redirectReducer;


// WEBPACK FOOTER //
// ./src/reducers/redirectReducer.js